import React, { useRef } from "react";
import { Box, Typography, Container, Grid,} from "@mui/material";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation, Autoplay} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import Ganapathy from '../assets/images/Chairman_Mr_Ganapathy.jpeg';
import bg from '../assets/images/Thirukadayur.jpg';
import pandian from '../assets/images/Pandian.JPG';
import Lakshmanaraj from '../assets/images/Lakshmanaraj.JPG';
import Paneerselvam from '../assets/images/Paneerselvam.JPG';
import Asokan from '../assets/images/Asokan.JPG';
import br from '../assets/images/bottom.png';
const teamMembers = [
  {
    name: "Mr Lakshmanaraj S",
    role: "Trustee and Treasurer",
    image: Lakshmanaraj,
    description: "S. Lakshmanaraj is the esteemed treasurer of Mayiladuthurai Senaithalaivar Sangam. Following in the footsteps of his father, P. Muthaya, who served the general public as a well-known advocate in Cuddalore, he served the educational welfare of the public as a public-school teacher in Sirkazhi. His service has guided many bright young minds from the rural regions to emerge and do well in their lives. His experience in education and public service will serve very well in the management of our charitable trust.",
  },
  {
    name: "Mr Paneerselvam V",
    role: "Trustee",
    image: Paneerselvam,
    description: "V. Paneerselvam is a valued member and EC member of Tamil Nadu Senaithalaivar Mahajan Sangam. He has served the general public and the wider agricultural community's welfare through his role as a senior agricultural officer in the government for over 40 years. His education at Gandhigram Rural University has instilled in him the values and ethos of Gandhian public service. These characteristics will enable him to assist our charitable trust in providing able public service to society.",
  },
  {
    name: "Mr Pandian K",
    role: "Trustee and President Mayiladuthurai Senaithaliavar Sangam",
    image: pandian,
    description: "K. Pandian is the esteemed president of Mayiladuthurai Senaithalaivar Sangam. Following in the footsteps of his father, M. Kannusamy, who served as a health inspector of government hospitals all over Tamil Nadu and also contributed to social services in our community, he has served in the education department in Mayiladuthurai District. Now he is a retired headmaster.",
  },
  {
    name: "Mr Ashokan G",
    role: "Trustee and Secretary",
    image: Asokan,
    description:
      "G. Ashokan, son of S. Govindaswamy, is a dedicated professional with a rich career in public health and sanitation. He holds a Diploma in Sanitary Inspection from Gandhigram Rural Institute, Dindigul. Mr. Ashokan served as a Sanitary Inspector at Thanjavur City Municipal Corporation, where he worked for 36 years and retired in 2023. In addition to his career, he is actively involved in community service as the Secretary of the Mayiladuthurai Senaithalaivar Sangam, where he continues to contribute to social causes and the well-being of his community.",
  },
];
function App() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  return (
    <Box>
    <Box
  sx={{
    backgroundImage: `url(${bg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center top 10%", // Moves the image down by 10%
    height: "80vh",
    width: "100vw",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: "white",
    position: "relative",
  }}
>

      {/* Overlay to improve readability */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.4)", // Dark overlay for better contrast
        }}
      />

      <Typography 
        variant="h2" 
        sx={{ fontWeight: "bold", zIndex: 1, color: "#FFCC03" }}
      >
        Leadership
      </Typography>
      
      <Typography 
        variant="h5" 
        sx={{ fontWeight: "bold", zIndex: 1, marginTop: 2, color: "white" }}
      >
        Guiding with vision, innovation, and excellence.
      </Typography>

    

      
    </Box>
   


{/*Mr Ganapathy Leadership section */}


<Box sx={{ backgroundColor: "#f8f9e9", py: 6 }}>
      <Container>
        
        <Grid container spacing={2} alignItems="center">
         
           {/* Left Image Section */}
           <Grid item xs={12} md={6} display="flex" justifyContent="center" >
            <Box component="img" src={Ganapathy} alt="Chairman Mr Ganapathy"
              sx={{ width: "80%",  
                maxWidth: "250px", 
                height: "auto",
                maxHeight: "300px",
                objectFit: "cover", 
                borderRadius: "8px", 
                boxShadow: 3}}
            />
          </Grid>
          <Grid item xs={12} md={6}>
          <Box sx={{  textAlign: "center", width: "85%" }}>
            <Typography variant="h2" sx={{ fontWeight: "bold", color: "#E52029",fontSize: "34px" }}>
            Chairman  <br></br><span style={{ color: "#FAD707" }}> Mr Ganapathy V</span>
          </Typography>
          </Box>
        </Grid>

              {/* Center Text Section */}
              <Grid item xs={12} sx={{ position: "relative" }}>
          <Swiper
                navigation={{
                  prevEl: ".custom-prev",
                  nextEl: ".custom-next",
                }}
                autoplay={{ delay: 90000, disableOnInteraction: false }}
                loop={true}
                modules={[Navigation, Autoplay]}
                className="swiper-container"
              >
    <SwiperSlide>
      <Typography
        variant="body1"
        sx={{ mt: 5, fontSize: "16px", color: "#000000", fontWeight: 500, lineHeight: 2, textAlign: "justify", px: 2 }}
      >
        Mr Ganapathy, a current honorary president/leader of the Senaithalaivar community, can be best described as a gentle giant among the 
        Senaithalaivar people and as a veritable fountain of knowledge and wisdom. With a rich life experience spanning over 50 decades all the 
        way from the time of India’s independence to the modern era of the 2020s, his contributions to enriching people from all walks of life 
        have been immense and thoughtful.<br /><br />
        Mr Ganapathy was born in the village of Erukattancherry (Mayiladuthurai District), in 1936. His father was an active participant in the maintenance
        and management of several temples in Erukattancherry  being the vice president of the Tranquebar town panchayat board. While Mr Ganapathy
        emigrated for work opportunities, he returned in the early 1990s to begin contributing donations for the welfare of several temples in 
        and around Erukattancherry . He has inculcated this characteristic among his children and grandchildren who have also made several 
        donations in this effort.<br /><br />
        Starting his formal association with the Senaithalaivar community by joining as a member in the Chennai Nagara Senaithalaivar Mahajana
        Sangam in the early 1980s. Followed by his progression to manage the organisation at a state level as a vice president of Tamil Nadu 
        Senaithalaivar Mahajana Sangam in early 2000s.<br /><br />
        In recognition of his administrative and organisational abilities, he was elected as president of Chennai Maavatta Senaithalaivar 
        Sangam for 3 years from 2006. During his tenure as president, he helped manage and organise large Kudumba vizha in all 3 years of his 
        presidency. These kudumba vizha were designed to help bring together the Senaithalaivar community living in Chennai city and surrounding
        regions. During the vizhas, young members of the community were accorded recognition for their personal achievements, especially in
        education. He became an honorary president in 2009 and continues to remain in this role to the present.<br /><br />
        Mr Ganapathy’s positive attributes and character can be displayed for all to see in his personal life: being the loving grandfather 
        of a multi-generational family, enduring friendships sustained over generations and networks accumulated over years. He has not only 
        developed these connections but made sincere efforts to remain engaged and in touch with these connections across many years.<br /><br />
      </Typography>
    </SwiperSlide>

    <SwiperSlide>
      <Typography
        variant="body1"
        sx={{ mt: 5, fontSize: "16px", color: "#000000", fontWeight: 500, textAlign: "justify", px: 2 }}
      >
        சேனைத்தலைவர் சமூகத்தின் கௌரவத் தலைவர்/தலைவரான திரு. கணபதி, சேனைத்தலைவர் மக்களிடையே ஒரு மென்மையான 
        ராட்சதர் என்றும், அறிவு மற்றும் ஞானத்தின் உண்மையான ஊற்று என்றும் சிறப்பாக விவரிக்கப்படலாம்.<br /><br />
        இந்தியா சுதந்திரம் பெற்ற காலம் முதல் 2020களின் நவீன சகாப்தம் வரை 50 தசாப்தங்களுக்கும் மேலாக நீடித்த வளமான வாழ்க்கை 
        அனுபவத்துடன், அனைத்து தரப்பு மக்களையும் வளப்படுத்த அவர் அளித்த பங்களிப்புகள் மகத்தானவை மற்றும் சிந்தனைமிக்கவை. 
        திரு. கணபதி 1936 ஆம் ஆண்டு தஞ்சாவூர் மாவட்டத்தில் உள்ள எருகாட்டஞ்சேரி கிராமத்தில் பிறந்தார். அவரது தந்தை டிரான்குபார் 
        நகர பஞ்சாயத்து வாரியத்தின் துணைத் தலைவராக எருகாட்டஞ்சேரியில் உள்ள பல கோயில்களின் பராமரிப்பு மற்றும் நிர்வாகத்தில் 
        தீவிரமாக பங்கேற்றார். திரு. கணபதி வேலை வாய்ப்புகளுக்காக குடிபெயர்ந்தபோது, 1990 களின் முற்பகுதியில் எருகாட்டஞ்சேரி 
        மற்றும் அதைச் சுற்றியுள்ள பல கோயில்களின் நலனுக்காக நன்கொடைகளை வழங்கத் தொடங்கினார். இந்த முயற்சியில் பல 
        நன்கொடைகளை வழங்கிய தனது குழந்தைகள் மற்றும் பேரக்குழந்தைகள் மத்தியில் இந்தப் பண்பை அவர் பதித்துள்ளார். 1980களின் 
        முற்பகுதியில் சென்னை நகர சேனைத்தலைவர் மகாஜன சங்கத்தில் உறுப்பினராகச் சேர்ந்து சேனைத்தலைவர் சமூகத்துடனான தனது 
        முறையான தொடர்பைத் தொடங்கினார். அதைத் தொடர்ந்து 2000களின் முற்பகுதியில் தமிழ்நாடு சேனைத்தலைவர் மகாஜன சங்கத்தின் 
        துணைத் தலைவராக மாநில அளவில் அமைப்பை நிர்வகிக்கும் அளவுக்கு அவர் முன்னேறினார். அவரது நிர்வாக மற்றும் நிறுவனத் 
        திறன்களை அங்கீகரிக்கும் விதமாக, 2006 முதல் 3 ஆண்டுகள் சென்னை மாவட்ட சேனைத்தலைவர் சங்கத்தின் தலைவராகத் 
        தேர்ந்தெடுக்கப்பட்டார். தலைவராக இருந்த காலத்தில், அவர் தனது 3 ஆண்டுகளிலும் பெரிய குடும்ப விழாவை நிர்வகிக்கவும் 
        ஒழுங்கமைக்கவும் உதவினார்.<br /><br />
        சென்னை நகரம் மற்றும் சுற்றியுள்ள பகுதிகளில் வாழும் சேனைத்தலைவர் சமூகத்தை ஒன்றிணைக்க உதவும் வகையில் இந்தக் குடும்ப 
        விழாக்கள் வடிவமைக்கப்பட்டுள்ளன. விழாக்களின் போது, சமூகத்தின் இளம் உறுப்பினர்களுக்கு அவர்களின் தனிப்பட்ட 
        சாதனைகளுக்காக, குறிப்பாக கல்வியில் அங்கீகாரம் வழங்கப்பட்டது. 2009 இல் அவர் கௌரவத் தலைவராக ஆனார், தற்போது வரை 
        இந்தப் பொறுப்பில் தொடர்கிறார். திரு. கணபதியின் நேர்மறையான பண்புகளையும் குணத்தையும் அவரது தனிப்பட்ட வாழ்க்கையில் 
        அனைவரும் காண முடியும்: பல தலைமுறைகளைக் கொண்ட குடும்பத்தின் அன்பான தாத்தாவாக இருப்பது, தலைமுறைகளாக நீடித்த 
        நீடித்த நட்புகள் மற்றும் பல ஆண்டுகளாக திரட்டப்பட்ட நெட்வொர்க்குகள். அவர் இந்த தொடர்புகளை வளர்த்துக் கொண்டது 
        மட்டுமல்லாமல், பல ஆண்டுகளாக இந்த தொடர்புகளுடன் ஈடுபாட்டுடனும் தொடர்பில் இருப்பதற்கும் உண்மையான முயற்சிகளை 
        மேற்கொண்டுள்ளார். 
      </Typography>
    </SwiperSlide>
  </Swiper>

  {/* Custom Navigation Buttons */}
  <button
  className="custom-prev"
  style={{
    position: "absolute",
    top: "50%",
    left: "0px",
    transform: "translateY(-50%)",
    background: "transparent", // Transparent background
    color: "black",
    padding: "10px",
    borderRadius: "50%",
    zIndex: 10,
    border: "none", // Remove border if needed
    cursor: "pointer",
    fontSize: "20px",
  }}
>
  ❮
</button>

<button
  className="custom-next"
  style={{
    position: "absolute",
    top: "50%",
    right: "-10px",
    transform: "translateY(-50%)",
    background: "transparent", // Transparent background
    color: "black",
    padding: "10px",
    borderRadius: "50%",
    zIndex: 10,
    border: "none", // Remove border if needed
    cursor: "pointer",
    fontSize: "20px",
  }}
>
  ❯
</button>
</Grid>


         
        </Grid>
      </Container>
      <Box
  sx={{
    position: "relative",
    left:"50%",
    width: "40%",
    height: { xs: "100px", md: "150px" }, // Responsive height
    backgroundImage: `url(${br})`,
    backgroundSize: "cover", // Ensures it covers the whole box
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    marginTop: { xs: "-50px", md: "-100px" }, // Adjusts margin for different screens
    zIndex: 0, // Keeps it behind other content
  }}
/>

     </Box>
     {/* Team Members Section */}
     <Box sx={{ backgroundColor: "#f8f9e9", py: 6, textAlign: "center" }}>
  <Typography variant="h4" sx={{ fontWeight: "bold", fontSize: "34px", color: "#FAD707" }}>
    <span style={{ color: "red" }}>Team</span> Members
  </Typography>

  <Container sx={{ mt: 4, position: "relative" }}> {/* Ensure relative positioning for absolute arrows */}
  <Swiper
    spaceBetween={30}
    slidesPerView={1}
    loop={true}
    autoplay={{ delay: 21000, disableOnInteraction: false }}
    navigation={{
      prevEl: ".custom-prev1",
      nextEl: ".custom-next1",
    }}
    modules={[Navigation, Autoplay]}
    breakpoints={{
      640: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
    }}
    className="swiper-container"
  >
    {teamMembers.map((member, index) => (
      <SwiperSlide key={index}>
        <Box
          sx={{
            backgroundColor: "#f8f9e9",
            boxShadow: 0,
            borderRadius: "12px",
            p: 3,
            textAlign: "center",
            minHeight: "590px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Box
            component="img"
            src={member.image}
            alt={member.name}
            sx={{ width: "200px", height: "200px" }}
          />
          <Typography variant="h" sx={{ fontWeight: "bold", color: "#E52029" }}>
            {member.name}
          </Typography>
          <Typography variant="body1" sx={{ color: "#666", fontWeight: "bold" }}>
            {member.role}
          </Typography>
          <Typography variant="body2" sx={{ color: "#333", textAlign: "justify", flexGrow: 1 }}>
            {member.description}
          </Typography>
        </Box>
      </SwiperSlide>
    ))}
  </Swiper>

  {/* Custom Navigation Buttons */}
  <button className="custom-prev1"
    style={{
      position: "absolute", 
      top: "50%", 
      left: "10px", 
      transform: "translateY(-50%)", 
      background: "#f8f9e9",
      padding: "10px",
      borderRadius: "50%",
      zIndex: 10,
      border: "none",
      cursor: "pointer",
      fontSize: "16px",
    }}>
    ❮
  </button>

  <button className="custom-next1"
    style={{
      position: "absolute", 
      top: "50%", 
      right: "10px", 
      transform: "translateY(-50%)", 
      background: "#f8f9e9",
      padding: "10px",
      borderRadius: "50%",
      zIndex: 10,
      border: "none",
      cursor: "pointer",
      fontSize: "16px",
    }}>
    ❯
  </button>
</Container>

</Box>


</Box>
  );
}

export default App;